import { Modal, Descriptions, Button, Tag, Space } from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const STATUS_CONFIG = {
  PENDING: { color: "orange", label: "Pendiente" },
  IN_PROGRESS: { color: "blue", label: "En progreso" },
  STOP_SELLING: { color: "red", label: "Sin lugar" },
  FINISHED: { color: "green", label: "Finalizada" },
};

function ExcursionDetailModal({ visible, excursion, onClose }) {
  const navigate = useNavigate();

  if (!excursion) return null;

  const statusConfig = STATUS_CONFIG[excursion.status] || STATUS_CONFIG.PENDING;

  const handleGoToArmado = () => {
    onClose();
    navigate(`/excursiones/${excursion.id}/buses`);
  };

  return (
    <Modal
      title={
        <Space>
          <span>{excursion.excursionType?.name || "Excursión"}</span>
          <Tag color={statusConfig.color}>{statusConfig.label}</Tag>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Cerrar
        </Button>,
        <Button key="armado" type="primary" onClick={handleGoToArmado}>
          Ir a Armado de Micros
        </Button>,
      ]}
      width={500}
    >
      <Descriptions column={1} bordered size="small" className="mt-4">
        <Descriptions.Item label="Fecha">
          {dayjs(excursion.day).format("DD/MM/YYYY")}
        </Descriptions.Item>
        <Descriptions.Item label="Pasajeros">
          {excursion.passengersCount || 0} pax
        </Descriptions.Item>
        <Descriptions.Item label="Butacas disponibles">
          {excursion.seats || 0}
        </Descriptions.Item>
        <Descriptions.Item label="Grupo">
          {excursion.group?.company?.name || "-"}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
}

export default ExcursionDetailModal;
